<template>
    <v-dialog
        v-model="dialogExpense"
        width="400"
        persistent
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                small
                color="error"
                class="text-capitalize"
                v-bind="attrs"
                v-on="on"
            >Nuevo gasto</v-btn>
        </template>

        <v-form @submit.prevent="registerExpense" lazy-validation ref="formExpense">
            <v-card :loading="loading" :disabled="loading">
                <v-card-title class="text-h5 grey lighten-2">
                    Nuevo gasto
                </v-card-title>

                <v-card-text class="pt-4">
                    <v-select
                        :items="itemsExpense"
                        label="Tipo de gasto *"
                        dense
                        outlined
                        v-model="form.type"
                        :rules="[rules.required]"
                    ></v-select>
                    <v-text-field
                        label="Descripción corta"
                        dense
                        outlined
                        v-model="form.description"
                    ></v-text-field>
                    <v-text-field
                        :label="`Monto en ${money}*`"
                        dense
                        outlined
                        type="number"
                        min="0"
                        v-model="form.amount"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-checkbox
                        label="Registro recurrente"
                        :false-value="0"
                        :true-value="1"
                        v-model="form.recurrent"
                    ></v-checkbox>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogExpense = false"
                        :disabled="loading"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        type="submit"
                        :loading="loading"
                    >
                        Registrar gasto
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({
        dialogExpense: false,
        itemsExpense: ['Sueldos personal', 'servicios básicos', 'alquileres', 'Insumos y materiales', 'otros'],
        form: {
            type: '',
            description: '',
            amount: '',
            recurrent: 0,
        },
        loading: false,
        rules: {
            required: value => !!value || 'Requerido.'
        }
    }),
    props: ['money'],
    methods: {
        async registerExpense() {
            if (this.$refs.formExpense.validate()) {
                this.loading = true

                await axios.post('/admin/new-expense', this.form)
                .then((response) => {
                    console.log(response);
                    if (response.data === 'ok') {
                        this.$notify.success('Gasto registrado con exito.')
                        this.form = {
                            type: '',
                            description: '',
                            amount: '',
                            recurrent: 0
                        }
                        this.$refs.formExpense.reset()
                        this.dialogExpense = false
                    }
                    this.loading = false
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        }
    }
}
</script>
